import {buildInputQuery, countTotalTokens, searchIndexedDB} from "./utils";
import {ChatModels} from "../constants";

export const fetchContextItems = async ({inputValue, messages, KB, contextWindow, renderSettings}) => {
    let totalTokens = 0;

    if (!inputValue && !messages?.length) {
        return { totalTokens, items: []}
    }

    const maxContextSize = Math.round(ChatModels?.[KB?.model]?.context * 0.8) || 8000;

    const query = buildInputQuery(inputValue, messages)
    const tokensFromMessages = countTotalTokens(messages);

    const tokensCapacityLeft = maxContextSize - tokensFromMessages - contextWindow;

    const tokensBudget = tokensCapacityLeft > 0
        ? contextWindow
        : contextWindow + (tokensCapacityLeft)

    // console.log('maxContextSize', maxContextSize)
    // console.log('contextWindow', contextWindow)
    // console.log('tokensFromMessages', tokensFromMessages)
    // console.log('tokensCapacityLeft', tokensCapacityLeft)
    // console.log('tokensBudget', tokensBudget)


    const items = await searchIndexedDB({ query, KB, maxTokens: tokensBudget, renderSettings })

    if (items?.length) {
        totalTokens = items.reduce((total, item) => total + item?.meta?.estimatedTokens, 0) || 0;
    }

    return { totalTokens, items}
};